import type { Tenant } from '#/graphql/types';
import type { ColumnProps } from '#/common/components/DataGrid';

const columns: ColumnProps<Tenant>[] = [
  { dataField: 'id', caption: 'ID', visible: false, showInColumnChooser: false },
  {
    dataField: 'name',
    caption: 'Name',
    visible: true,
    openOnClick: true,
    dataType: 'string',
    sortIndex: 0,
    sortOrder: 'desc',
  },
  {
    dataField: 'address',
    caption: 'Address',
    visible: true,
    openOnClick: false,
    dataType: 'string',
  },
  {
    dataField: 'contacts',
    caption: 'Contacts',
    visible: false,
    openOnClick: false,
    dataType: 'string',
  },
  {
    dataField: 'isActive',
    caption: 'Active',
    visible: true,
    openOnClick: false,
    dataType: 'boolean',
  },
  {
    dataField: 'cognitoGroupName',
    caption: 'Cognito Group',
    visible: false,
    openOnClick: false,
    dataType: 'string',
  },
  {
    dataField: 'tisId',
    caption: 'TIS ID',
    visible: true,
    openOnClick: false,
    dataType: 'string',
  },
  {
    dataField: 'plan',
    caption: 'Plan',
    visible: true,
    openOnClick: false,
    dataType: 'string',
    lookup: {
      nullable: true,
      dataSource: [
        { key: 'starter', label: 'Starter' },
        { key: 'basic', label: 'Basic' },
        { key: 'professional', label: 'Professional' },
        { key: 'enterprise', label: 'Enterprise' },
        { key: 'max', label: 'Max' },
      ],
      displayExpr: 'label',
      valueExpr: 'key',
    },
  },
];

export default columns;
